import React from 'react';

import { CircleLoaderComponent } from 'react/CircleLoaderComponent.jsx';
import { StreamsComponent } from 'react/stream/StreamsComponent.jsx';

import PropTypes from 'prop-types';
import { Stream } from '../../models/Stream';
import store from 'react/redux/store/store';
import * as featuredStreamActions from '../redux/actions/featuredStreams';
import LoaderFullPage from '../elements/LoaderFullPage';
import EmptyMatchmakingTabComponent from '../elements/EmptyMatchmakingTabComponent';

export default class StreamsTabStreamsComponent extends React.Component {
	static propTypes = {};

	constructor(props) {
		super(props);
		this.games = [];
		this.streamList = [];
		this.state = {
			filters: {},
			streamList: [],
		};

		this.filterIsOnForStream = this.filterIsOnForStream.bind(this);
	}

	componentDidMount() {
		store.dispatch(featuredStreamActions.retrieveExternalStreams());
	}

	componentDidUpdate() {
		this.updateGameData();
	}

	updateGameData() {
		const { streams } = this.props;
		let games = new Map();
		const streamList = Array.from(streams).sort((a, b) => {
			if(a.viewers === b.viewers) {
				return 0;
			}
			return a.viewers > b.viewers ? -1 : 1;
		});
		for(let stream of streamList) {
			if(stream.gameData && !games.has(stream.gameData)) {
				const gameData = stream.gameData;
				games.set(stream.gameData, gameData);
			}
		}

		games = Array.from(games).map(([_, gameData]) => {
			return gameData;
		});
		if(!_.isEqual(streamList, this.streamList)) {
			this.streamList = streamList;
		}
		if(!_.isEqual(games, this.games)) {
			this.games = games;
			this.forceUpdate();
		}
	}

	toggleFilter(filterName) {
		this.setState((prevState) => {
			const value = prevState.filters[filterName];
			let setTo = null;
			if(value === undefined) {
				setTo = false;
			}
			else {
				setTo = !prevState.filters[filterName];
			}
			const newState = {};
			newState.filters = prevState.filters;
			newState.filters[filterName] = setTo;
			return newState;
		});
	}

	filterIsOn(filterName) {
		const filterValue = this.state.filters[filterName];
		if(filterValue === undefined) {
			return true;
		}
		return filterValue;
	}

	filterIsOnForStream(stream) {
		if(stream.gameData) {
			return this.filterIsOn(stream.gameData.id);
		}
		return true;
	}

	render() {
		const { streams, retrievingExternalStreams } = this.props;
		const streamList = this.streamList;

		return (
			<div className={`active_twitch_streams stream_container ${retrievingExternalStreams ? 'loading' : ''}`}>
				{streamList.length === 0 && retrievingExternalStreams && <LoaderFullPage
					text='Retrieving Streams'
				/>}
				<div className='stream_filters active_selectables'>
					{this.games.map((gameData) => (
						<div
							key={gameData.id}
							onClick={this.toggleFilter.bind(this, gameData.id)}
							className={`stream_filter  ${(this.filterIsOn(gameData.id) ? 'active' : '')}`}>
							<img src={gameData.logo}
							     className='game_logo' />
						</div>
					))}
				</div>
				{(!retrievingExternalStreams || streamList.length > 0) &&
				<div className='active_streams'>
					<StreamsComponent
						filterIsOnForStream={this.filterIsOnForStream}
						streams={streamList}
						emptyContent={
							<EmptyMatchmakingTabComponent>
								No Streams to Show
							</EmptyMatchmakingTabComponent>
						}
					/>
				</div>
				}
			</div>
		);
	}

}